<!--  -->
<template>
  <div class="muted-video">
    <video
      :width="width"
      :height="height"
      controls
      autoplay
      muted
      loop
      webkit-playsinline
      playsinline
      x5-playsinline
      x5-video-player-type="h5"
      x5-video-player-fullscreen="false">
      <source :src="src" type="video/mp4" />
      您的浏览器不支持 video 标签。
    </video>

    <!-- <div id="dplayer"></div> -->

    <!-- <video
      :width="width"
      :height="height"
      :src="src"
      id="autoplay_a1"
      controls="controls"
      x5-video-player-type="h5"
      preload="metadata"
      playsinline="true"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      x5-video-orientation="portraint"
      x5-video-player-fullscreen="true">
      您的浏览器不支持 video 标签
    </video> -->
    <!-- <video
      :width="width"
      :height="height"
      src="https://o3.xiaohongshu.com/video/red15s.mp4"
      controls
      autoplay
      muted
      loop
      preload="metadata"
      webkit-playsinline="true"
      playsinline="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true">
      您的浏览器不支持 video 标签
    </video> -->
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  // import DPlayer from "dplayer";

  export default {
    name: "",
    mixins: [],
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      id: {
        type: [String, Number],
        default: "dplayer",
      },
      src: {
        type: [String],
        default: "",
        requeire: true,
      },
      width: {
        type: [String],
        default: "100%",
      },
      height: {
        type: [String],
        default: "100%",
      },
    },
    data() {
      // 这里存放响应式数据
      return {
        dp: "",
      };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      src: {
        handler(newVal, oldVal) {
          // console.log({ newVal, oldVal });
        },
        immediate: true,
      },
    },

    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      // this.init();
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会激活时调用
    deactivated() {}, // 如果页面有keep-alive缓存功能，这个函数会停用时调用
    // 方法集合
    methods: {
      init() {
        const { src } = this;
        console.log("src", src);
        const dom = document.getElementById("dplayer");
        this.dp = new DPlayer({
          container: dom,
          volume: 0, // 默认0.7
          // autoplay: true, // 谷歌新政策静音才会自动播放
          loop: true,
          // hotkey: false, // 开启热键
          mutex: false, // 互斥，阻止多个播放器同时播放
          video: {
            url: src,
          },
        });
        this.dp.play(); // 播放方法
      },
    },
  };
</script>

<style lang="scss" scoped>
  // @import './index.scss'; // 引入当前页面scss类文件
  .muted-video {
    // background-color: red;

    #dplayer,
    video {
      border-radius: 10px;
      vertical-align: middle;
    }

    /* 隐藏video 所有控件 */
    // video::-webkit-media-controls-enclosure {
    //   display: none;
    // }
  }
</style>
